import { createEffect } from 'effector'
import { getEgsConnect, getEpicRefresh } from './api'

export const getEpicRefreshFx = createEffect(async (token: string) => {
  const data = await getEpicRefresh(token)
  return data
})
export const getEpicConnectFx = createEffect(async (token: string) => {
  const data = await getEgsConnect(token)
  return data
})
